import type { ShopifySectionComponent } from '@/types/ShopifySectionComponent'
import { Button, Icon, Text, useMediaQuery } from '@lounge-fe/ui-kit'
import { useOfferButtonStore } from './store'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { DiscountModalTrigger } from '../Modals/DiscountModal'
import { InnerButtonProps } from './types'

interface OfferButtonProps {
  discount_modal_override: boolean
  label: string
  modal_id: string
}

const InnerButton: React.FC<InnerButtonProps> = ({ href, onClick, label }) => {
  const { t } = useTranslation()
  const isDesktop = useMediaQuery(({ screens }) => `(min-width: ${screens.sm})`)

  const handleClose = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    onClick()
  }

  return (
    <Button
      as={href ? 'a' : undefined}
      href={href}
      variant="solid"
      className="text-black normal-case bg-primary p-4 shadow-[0_12px_16px_0_rgba(0,0,0,0.12)] hover:text-black hover:bg-primary"
      endIcon={
        <span
          onClick={handleClose}
          className="ml-1 w-3 h-3"
          aria-label={t('action.close')}
        >
          <Icon.Close className="w-3 h-3" />
        </span>
      }
    >
      <Text variant={isDesktop ? 'title-six' : 'title-five'}>{label}</Text>
    </Button>
  )
}

export const OfferButton: ShopifySectionComponent<OfferButtonProps> = ({
  data,
}) => {
  const { discount_modal_override, label, modal_id } = data!

  const { isDismissed, dismiss, checkDismissed } = useOfferButtonStore()

  useEffect(() => {
    checkDismissed()
  }, [])

  if (!label || isDismissed) return null

  return (
    <div className="fixed bottom-4 right-5 z-50 flex justify-start w-fit">
      {discount_modal_override ? (
        <DiscountModalTrigger as="div">
          <InnerButton onClick={dismiss} label={label} />
        </DiscountModalTrigger>
      ) : (
        <InnerButton href={`#${modal_id}`} onClick={dismiss} label={label} />
      )}
    </div>
  )
}
